export const isProductionClient = typeof window !== 'undefined' && window.location.hostname.includes('engelvoelkers.com');
